// Converts a student record from student_crud.php (GET ?guid=) into the shape the
// AddStudent form expects. Shared by the Student list and the Student Detail page so
// both pre-fill the edit form the same way (the detail page used to pass the raw API
// record, so fields like previous school were empty and got erased on save).
const mapStudentForForm = (s) => {
  // The API returns parent_first / parent_last separately. Splitting parent_name at
  // spaces dropped words ("ashok bheem rao.B" → last name "bheem").
  const nameParts = (s.parent_name || "").trim().split(/\s+/);
  const parentFirst = s.parent_first ?? nameParts[0] ?? "";
  const parentLast = s.parent_last ?? nameParts.slice(1).join(" ");

  return {
    // ids
    guid: s.guid,
    id: s.id || "",

    // student basic
    admission_number: s.admission_number || "",
    firstName: s.first_name || "",
    lastName: s.last_name || "",
    gender: s.gender || "",
    dob: s.date_of_birth || "",
    age: s.age || "",
    blood_group: s.blood_group || "",
    nationality: s.nationality || "",
    religion: s.religion || "",
    place_of_birth: s.place_of_birth || "",
    place_of_origin: s.place_of_origin || "",

    // class / branch
    class: s.class_guid || "",
    class_name: s.class_name || "",
    branch: s.branch_guid || "",
    joiningDate: s.joining_date || "",
    status: s.isActive == 1 ? "Active" : "Inactive",
    isActive: s.isActive,

    // profile
    profile_photo: s.profile_photo || "",
    remarks: s.remarks || "",

    // address
    address: s.address || "",

    // parent
    parent_guid: s.parent_guid || "",
    parent_first_name: parentFirst,
    parent_last_name: parentLast,
    parent_photo: s.parent_photo || "",
    parentPhone: s.parent_phone || "",
    parentEmail: s.parent_email || "",
    parentPassword: s.parent_password || "",
    occupation: s.occupation || "",
    qualification: s.qualification || "",
    placeofwork: s.placeofwork || "", // was missing → every edit blanked the father's place of work
    username: (() => {
      if (s.admission_number) {
        const parts = s.admission_number.split("-");
        if (parts.length >= 2) {
          const seq = parseInt(parts[1], 10);
          if (!isNaN(seq)) {
            return "RM" + String(seq).padStart(7, "0");
          }
        }
      }
      return s.username || "";
    })(),

    // mother
    mother_first_name: s.mother_first_name || "",
    mother_last_name: s.mother_last_name || "",
    mother_mobile: s.mother_mobile || "",
    mother_email: s.mother_email || "",
    mother_qualification: s.mother_qualification || "",
    mother_work_place: s.mother_placeofwork || "",
    mother_address: s.mother_address || "",
    mother_occupation: s.mother_occupation || "",
    mother_tongue: s.mother_tongue || "",

    // medical
    allergy_status: s.allergy_status || "No",
    allergies: s.allergies || "",
    surgery_status: s.surgery_status || "No",
    surgeries: s.surgeries || "",
    chronic_illness_status: s.chronic_illness_status || "No",
    chronicIllness: s.chronicIllness || "",
    immunization_status: s.immunization_status || "",

    // emergency
    emergency_contact_name: s.emergency_contact_name || "",
    emergency_contact_phone: s.emergency_contact || "",
    emergency_relationship: s.emergency_contact_relation || "",
    emergency_contact_address: s.emergency_contact_address || "",

    // guardian
    guardian_name: s.guardian_name || "",
    guardian_relationship: s.guardian_relation || "",
    guardian_phone: s.guardian_phone || "",
    guardian_mobile: s.guardian_mobile || "",

    // previous school
    previously_attended_school:
      s.attended_school_before === "Yes" ? "yes" : "no",
    previous_school_name: s.previous_school || "",
    previous_school_duration: s.previous_school_duration || "",
    previous_school_class: s.previous_class_attended || "",

    // declaration
    declaration_parent_name: s.declaration_signed_by || "",
    declaration_date: s.declaration_date || "",
    declaration_signed_by: s.declaration_signed_by || "",

    // extra
    documents: s.documents || [],
    siblings: s.siblings || [],
    tuition_fee: s.tution_fee || "",
  };
};

export default mapStudentForForm;
